import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'confirm-delete',
    standalone: true,
    imports: [],
    templateUrl: './confirm-delete.component.html'
})
export class ConfirmDeleteComponent {
    @Input() title: string = 'Confirm Delete';
    @Input() message: string = 'Are you sure you want to delete this item?';

    constructor(public activeModal: NgbActiveModal) {}

    public confirm() {
        this.activeModal.close('confirmed');
    }

    public cancel() {
        this.activeModal.dismiss('cancelled');
    }
}
